import { css } from '@emotion/core';
var cancelIcon = {
  name: "1svs0zz",
  styles: "position:relative;top:-1px;width:18px;height:18px;"
};
export default cancelIcon;